<template>
  <div
    id="assistant-step-4"
    class="assistant-forms" >
    <h2 class="title">Fine-tuning and customization</h2>
    <p class="subtitle">Provide instructions and actions to fine-tune your AI assistant's responses.</p>

    <JsonSchema
      ref="jsonSchema"
      v-model="value"
      :schema="schema | processSchema"
      :components="componentsConfig"
      :ui-schema="uiSchema"
      :wrapper="wrapperComponentConfig"
      @init-default="initDefault"
      @input="() => {}" />

    <!-- <div> dataModel </div> -->
    <!-- <pre class="debug"> {{ value }} </pre> -->
  </div>
</template>

<script>
// TODO - check this code before publishing Assistants feature

import JsonSchema from '@roma219/vue-jsonschema-form';
import { debounce } from 'debounce';

import SBIconList from '@/helpers/lists/sb-icon-list';
import ToasterMixin from '../../../mixins/Toaster';

const schemaBP = {
  type: 'object',
  properties: {
    unsupportedActions: {
      title: 'Unsupported actions',
      value: [
        'Never book a call or in-person meeting.',
      ],
      type: 'input-list',
      subtitleTopPrefixIcon: SBIconList.INFO,
      subtitleTop: 'Add actions that the AI should avoid to prevent unwanted responses.',
      placeholder: 'Never book a call or in-person meeting.',
      validators: 'required',
      validatorMessages: {
        required: 'Field is required.',
      },
      addButtonText: 'Add unsupported action',
    },
    inPerson: {
      title: 'Custom instructions',
      value: [
        'If a contact asks an unclear question, politely ask for clarification.',
      ],
      type: 'input-list',
      subtitleTopPrefixIcon: SBIconList.INFO,
      subtitleTop: 'Add specific guidelines to fine-tune the AI\'s responses.',
      placeholder: 'If a contact asks an unclear question, politely ask for clarification.',
      validators: 'required',
      validatorMessages: {
        required: 'Field is required.',
      },
      addButtonText: 'Add custom instruction',
    },
    followUp: {
      type: 'object',
      title: 'Follow-up actions',
      properties: {
        duration: {
          type: 'duration',
          title: 'If a chat is unresolved and a contact doesn\'t respond for',
          placeholder: '23',
          maxSeconds: 82800,
          maxSecondsMessage: 'Waiting time can be up to 23 hours.',
          noDefault: true,
          hideOptional: true,
          hideScopes: ['days'],
          // value: 'Hmm, I don\'t have the information you\'re looking for. Would you like me to connect you with our support team for further assistance?',
        },
        buttons: {
          title: 'Then',
          value: [
            { title: 'Send a follow up message', fixed: true, subtitlePrefixIcon: SBIconList.INFO, subtitle: 'AI will send a follow-up message.' },
          ],
          type: 'message-buttons',
          returnKey: 'responseButtons',
          hideOptional: true,
        },
        actionsTest: {
          value: [],
          type: 'action-buttons',
          options: [
            { value: 1, label: 'Move chat to the Done folder' },
            { value: 2, label: 'Unassign chat and mark it as unread'},
          ],
          addActionIcon: SBIconList.PLUS,
          addActionText: 'Add action',
          returnKey: 'responseActions',
        },
      },
    },
  },
};

const image = require('@/assets/img/SB-Icons/settings.svg'); // this is local image example.

export default {
  name: 'AssistantStep3',
  components: {
    JsonSchema,
  },
  mixins: [ToasterMixin],
  data() {
    return {
      initialized: false,
      steps: 4,
      currentStep: 1,
      initializedSteps: [],
      value: {},
      stepImage: image,
      showShema: false,
      // uiSchema: {
      //   bio: {
      //     'ui:options': {
      //       placeholder: 'Please enter your bio.',
      //       type: 'textarea',
      //       rows: 1,
      //     },
      //   },
      // },
      // uiSchema: {
      //   properties: {
      //     text: {
      //       uiType: 'b-input',
      //     },
      //   },
      // },
      schemaBlueprint: {
        type: 'object',
        properties: {
          test: {
            type: 'input',
            title: 'Test',
            placeholder: 'Test',
            validators: 'required',
            subtitlePrefixIcon: SBIconList.INFO,
            subtitle: 'Test subtitle.',
          },
          typeForm: {
            showIf: {
              input: 'test',
              value: 'aaa',
            },
            type: 'object',
            title: 'Blabla Condition',
            properties: {
              efghij: {
                type: 'input',
                title: 'Test',
                placeholder: 'Test',
                validators: 'required',
                subtitlePrefixIcon: SBIconList.INFO,
                subtitle: 'Test subtitle.',
              },
            },
          },
          type: {
            value: 1,
            type: 'dropdown',
            title: 'Type of AI',
            placeholder: 'Select type of AI',
            validators: 'required',
            subtitlePrefixIcon: SBIconList.INFO,
            subtitle: 'AI in type of {{ option }}.',
            options: [
              { value: 1, label: 'One', color: 'red' },
              { value: 2, label: 'Two', color: 'green' },
              { value: 3, label: 'Three', color: 'blue' },
            ],
            width: 50,
          },
          a: {
            type: 'input',
            title: 'Username',
          },
          b: {
            type: 'object',
            title: 'Blabla',
            properties: {
              e: {
                type: 'input',
                title: 'Is Admin',
              },
              f: {
                type: 'dropdown',
                title: 'Currency format',
                placeholder: 'USD ($100,00.00)',
                options: [
                  { value: 'USD', label: 'USD ($100,00.00)' },
                  { value: 'CAD', label: 'CAD (100,00.00$)' },
                  { value: 'HR', label: 'HR (100,00.00€)' },
                ],
                width: 50,
                subtitlePrefixIcon: SBIconList.INFO,
                subtitle: 'Select the format that AI will use in replies.',
              },
            },
          },
        },
        // if: {
        //   properties: {
        //     test: {
        //       const: 'aaa',
        //     },
        //   },
        // },
        // then: {
        //   properties: {
        //     typeForm: {
        //       show: true,
        //     },
        //   },
        // },
      },
      componentsConfig: [
        {
          componentName: 'BInputWrapper',
          uiSchemaMatcher: { uiType: 'BInputWrapper' },
          // eventName: 'changeInput',
          props: (propName, schema, uiSchema) => {
            // console.log('propName', propName);
            // console.log('schema', schema);
            // console.log('uiSchema', uiSchema);
            return {
              'full-width': true,
              class: 'sb2-bordered sb2-hoverable sb2-focusable',
              placeholder: schema.placeholder,
              validators: schema.validators,
              schema,
            };
          },
        },
        {
          componentName: 'SBTextareaWrapper',
          uiSchemaMatcher: { uiType: 'SBTextareaWrapper' },
          // eventName: 'changeInput',
          props: (propName, schema, uiSchema) => {
            return {
              'full-width': true,
              class: 'sb2-bordered sb2-hoverable sb2-focusable',
              placeholder: schema.placeholder,
              validators: schema.validators,
              schema,
            };
          },
        },
        {
          componentName: 'SBDropdownWrapper',
          uiSchemaMatcher: { uiType: 'SBDropdownWrapper' },
          // eventName: 'changeInput',
          props: (propName, schema, uiSchema) => {
            // console.log('DROPDOWN');
            // console.log(uiSchema);
            return {
              class: 'sb2-bordered sb2-hoverable sb2-focusable',
              placeholder: schema.placeholder,
              validators: schema.validators,
              required: schema.validators ? schema.validators.split('|').includes('required') : false,
              schema,
              // 'ui-schema': uiSchema,
            };
          },
        },
        {
          componentName: 'NMBRButtonsWrapper',
          uiSchemaMatcher: { uiType: 'NMBRButtonsWrapper' },
          props: (propName, schema, uiSchema) => {
            return {
              'full-width': true,
              class: 'sb2-bordered sb2-hoverable sb2-focusable',
              placeholder: schema.placeholder,
              validators: schema.validators,
              schema,
            };
          },
        },
        {
          componentName: 'DividerWrapper',
          // uiSchemaMatcher: { uiType: 'DividerWrapper' },
          matcher: { type: 'dividerFull' },
          props: (propName, schema, uiSchema) => {
            return {
              'full-width': true,
              schema,
            };
          },
        },
        {
          componentName: 'DividerWrapper',
          // uiSchemaMatcher: { uiType: 'DividerWrapper' },           // IMPORTANT: maybe uiSchema is not needed
          matcher: { type: 'divider' },
          props: (propName, schema, uiSchema) => {
            return {
              'full-width': false,
              schema,
            };
          },
        },
        {
          componentName: 'SkeletonWrapper',
          // uiSchemaMatcher: { uiType: 'DividerWrapper' },           // IMPORTANT: maybe uiSchema is not needed
          matcher: { type: 'skeleton' },
          props: (propName, schema, uiSchema) => {
            return {
              'full-width': false,
              schema,
            };
          },
        },
        {
          componentName: 'NMBRActionsWrapper',
          matcher: { type: 'action-buttons' },
          props: (propName, schema, uiSchema) => {
            return {
              class: 'sb2-bordered sb2-hoverable sb2-focusable',
              validators: schema.validators,
              schema,
            };
          },
        },
        {
          componentName: 'DurationWrapper',
          matcher: { type: 'duration' },
          props: (propName, schema, uiSchema) => {
            return {
              validators: schema.validators,
              // value: schema.value,                                   // NOTE: the Number value can't be accepted. It needs object that we need to standardize.
              minSeconds: schema.minSeconds,
              minSecondsMessage: schema.minSecondsMessage,
              maxSeconds: schema.maxSeconds,
              maxSecondsMessage: schema.maxSecondsMessage,
              schema,
            };
          },
        },
        {
          componentName: 'InputListWrapper',
          matcher: { type: 'input-list' },
          props: (propName, schema, uiSchema) => {
            return {
              class: 'sb2-bordered sb2-hoverable sb2-focusable',
              validators: schema.validators,
              placeholder: schema.placeholder,
              schema,
            };
          },
        },
      ],
      wrapperComponentConfig: {
        componentName: 'SBCustomWrapperJSONForms',
        props: (propName, schema, uiSchema) => ({
          title: 'asd' || schema.title || schema.title === '' ? schema.title : propName,
          required: schema.validators ? schema.validators.split('|').includes('required') : false,
          disabled: uiSchema && uiSchema.disabled,
          errorMessage: schema.errorMessage,
          vertical: schema.type === 'object' || schema.type === 'array',
          schema,
        }),
      },
    };
  },
  computed: {
    schema() {
      // console.log('schemaBlueprint PROC', schemaBP);
      // const schema = { ...schemaBP };

      const schema = this.value ? this.filterSchema(JSON.parse(JSON.stringify(schemaBP))) : {};

      // console.log('schema PROC', schema);
      return schema;
      // return {
      //   type: 'object',
      //   properties: {
      //     test: {
      //       type: 'input',
      //       title: 'Test',
      //       placeholder: 'Test',
      //       validators: 'required',
      //       subtitlePrefixIcon: SBIconList.INFO,
      //       subtitle: 'Test subtitle.',
      //     },
      //   },
      // };
    },
    /** Schema needs to be proccesed because some inputs can take less than 100% width and according to the number of elements in a row the appropriate  */
    // proccessedSchema() {
    //   return this.schema;
    // },
    uiSchema() {
      const uiSchema = {
        properties: {
          // b: {
          //   properties: {
          //     c: {
          //       uiType: 'BInputWrapper',
          //     },
          //     d: {
          //       uiType: 'SBDropdownWrapper',
          //     },
          //   },
          // },
        },
      };
      // Object.keys(this.schema.properties).forEach((prop) => {
        // switch (this.schema.properties[prop].type) {
        //   case 'input':
        //     console.log('input');
        //     console.log(prop);
        //     uiSchema.properties[prop] = {
        //       uiType: 'BInputWrapper',
        //     };
        //     break;
        //   case 'textarea':
        //     uiSchema.properties[prop] = {
        //       uiType: 'SBTextareaWrapper',
        //     };
        //     break;
        //   case 'dropdown':
        //     uiSchema.properties[prop] = {
        //       uiType: 'SBDropdownWrapper',
        //     };
        //     break;
        //   case 'message-buttons':
        //     uiSchema.properties[prop] = {
        //       uiType: 'NMBRButtonsWrapper',
        //     };
        //     break;
        //   case 'number':
        //     // uiSchema.properties[prop] = {
        //     //   uiType: 'b-input',
        //     // };
        //     break;
        //   case 'boolean':
        //     // uiSchema.properties[prop] = {
        //     //   uiType: 'b-input',
        //     // };
        //     break;
        //   case 'subform':
        //     uiSchema.properties[prop] = {
              
        //     };
        //     break;
        //   default:
        //     console.log('default');
        //     console.log(prop);
        //     // uiSchema.properties[prop] = {
        //     //   uiType: 'BInputWrapper',
        //     // };
        //     break;
        // }
      // });
      uiSchema.properties = {
        ...uiSchema.properties,
        ...this.proccessUiSchema(this.schema).properties,
      };
      // console.log('uiSchema', uiSchema);
      return uiSchema;
    },
  },
  watch: {
    value: {
      handler() {
        // console.log('value', this.value);
        // console.log('checkData valid', (!this.$refs.jsonSchema.$v.$invalid).toString());
        this.$nextTick(() => {
          this.checkData();
        });
      },
      deep: true,
    },
  },
  updated() {
    this.focusOnInit();
  },
  mounted() {
    setTimeout(() => {
      // console.log('SHOWWW');
      this.showShema = true;
    }, 5000);
    window.eventBus.$on('assistantStepsInit', this.stepInit);
  },
  methods: {
    stepInit(data) {
      this.initializedSteps.push(data.step);
      if (this.initializedSteps.length === this.steps) {
        this.focusFirstInput();
      }
    },
    focusOnInit: debounce(function f() {
      if (!this.initialized) {
        window.eventBus.$emit('assistantStepsInit', { step: 4 });
        this.initialized = true;
      }
    }, 100),
    focusFirstInput() {
      if (this.currentStep === 4) {
        // Find first input field and focus it
        const input = document.getElementById('assistant-step-4').querySelector('input, .ql-editor');
        if (input) input.focus();
      }
    },
    filterSchema(schema) {
      // console.log('filterSchema', schema);
      // console.log('filterSchema', schema.properties);
      // const filteredSchema = {
      //   ...schema,
      //   properties: {},
      // };
      // const schemaCopy = { ...schema };
      Object.keys(schema.properties).forEach((key) => {
        const prop = schema.properties[key];
        if (prop.showIf) {
          const { input, value } = prop.showIf;
          // console.log('test PROC', this.value[input], value);
          if (
            !this.value[input] ||
            !this.value[input].data ||
            (
              this.value[input].data.value !== value &&
              (!Array.isArray(value) || !value.includes(this.value[input].data.value))
            )
          ) {
            // console.log('DELETE PROC', key);
            delete schema.properties[key];
            delete this.value[key];
          } else {
            // const controlField = this.findFieldInSchema(schemaBP, input);
            // console.log('controlField PROC', this.value[input].data.color);
            schema.properties[key].color = this.value[input].data.color;
          }
        }
        if (schema.properties && schema.properties[key] && prop.type === 'object') {
          schema.properties[key] = this.filterSchema(prop);
        }
      });
      return schema;
    },
    findFieldInSchema(schema, key) {
      if (schema.properties && schema.properties[key]) {
        return schema.properties[key];
      }
      Object.keys(schema.properties).forEach((prop) => {
        if (schema.properties[prop].type === 'object') {
          return this.findFieldInSchema(schema.properties[prop], key);
        }
      });
      return null;
    },
    proccessUiSchema(schema) {
      const uiSchema = {
        properties: {},
      };
      Object.keys(schema.properties).forEach((prop) => {
        switch (schema.properties[prop].type) {
          case 'input':
            // console.log('input');
            // console.log(prop);
            uiSchema.properties[prop] = {
              uiType: 'BInputWrapper',
            };
            break;
          case 'textarea':
            uiSchema.properties[prop] = {
              uiType: 'SBTextareaWrapper',
            };
            break;
          case 'dropdown':
            uiSchema.properties[prop] = {
              uiType: 'SBDropdownWrapper',
            };
            break;
          case 'message-buttons':
            uiSchema.properties[prop] = {
              uiType: 'NMBRButtonsWrapper',
            };
            break;
          // case 'dividerFull':
          //   uiSchema.properties[prop] = {
          //     uiType: 'DividerWrapper',
          //   };
          //   break;
          case 'number':
            // uiSchema.properties[prop] = {
            //   uiType: 'b-input',
            // };
            break;
          case 'boolean':
            // uiSchema.properties[prop] = {
            //   uiType: 'b-input',
            // };
            break;
          case 'object':
            // uiSchema.properties[prop] = {
            uiSchema.properties[prop] = {
              properties: {
                ...this.proccessUiSchema(schema.properties[prop]).properties,
              },
            };
            // };
            break;
          default:
            // console.log('default');
            // console.log(prop);
            // uiSchema.properties[prop] = {
            //   uiType: 'BInputWrapper',
            // };
            break;
        }
      });
      // console.log('returning uiSchema', uiSchema);
      return uiSchema;
    },
    checkFormValid(form) {
      return !Object.keys(form).some((component) => {
        // First check if it has 'Value' key. If it doesn't have it then this is a subform and it needs to be passed to the checkData function recursively.
        if (form[component].valid === undefined) {
          if (!this.checkFormValid(form[component])) {
            return true;
          }
          return false;
        }
        if (form[component] && form[component].valid === false) {
          return true;
        }
        return false;
      });
    },
    checkData() {
      const formValid = this.checkFormValid(this.value);

      this.$emit('input', {
        valid: formValid,
        name: 'assistantStep1',
        data: this.value,
      });
    },
    initDefault(v) {
      this.value = v;
    },
  },
};
</script>

<style scoped>
</style>
